import { render, staticRenderFns } from "./Study.vue?vue&type=template&id=73f1bcb1&"
import script from "./Study.ts?vue&type=script&lang=ts&"
export * from "./Study.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports